(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('zen-observable')) :
	typeof define === 'function' && define.amd ? define(['exports', 'zen-observable'], factory) :
	(factory((global.apolloLink = global.apolloLink || {}, global.apolloLink.zenObservable = {}),global.Observable));
}(this, (function (exports,zenObservable) { 'use strict';

	zenObservable = zenObservable && zenObservable.hasOwnProperty('default') ? zenObservable['default'] : zenObservable;

	/* tslint:disable */
	var Observable = zenObservable;

	exports.default = Observable;
	exports.Observable = Observable;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bundle.umd.js.map



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/apollo-link-error/~/zen-observable-ts/lib/bundle.umd.js
// module id = 854
// module chunks = 168707334958949